<template>
  <div>
    <a :href="lfeUrl" class="edume-link" target="_blank">
      <div :style="[cssVars]" class="edume-container">
        <!-- Could replace this with a single default slot and pass in a new component from Widget.vue -->
        <div class="edume-image">
          <slot name="image" />
        </div>
        <div class="edume-text-container">
          <h5>
            <slot name="title" />
          </h5>
          <p class="edume-due-date">
            <slot name="dueDate" />
          </p>
          <p class="edume-text-slot">
            <slot name="text" />
          </p>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    lfeUrl: {
      type: String,
      required: true,
    },
    appColour: {
      type: String,
      required: true,
    },
  },
  computed: {
    // This is how you do CSS variables in Vue...
    cssVars() {
      return {
        '--image-size': '72px',
        '--app-colour': this.appColour,
      };
    },
  },
};
</script>

<style scoped>
.edume-link {
  display: block;
  text-decoration: none;
}

.edume-container {
  color: #202021;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: auto;
  min-height: var(--image-size);
  position: relative;
  flex: 0 0 auto;
}

.edume-text-container {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  align-self: stretch;
  gap: 2px;
  margin: 0 15px 0 var(--image-size);
  padding: 8px;
}

.edume-text-container h5 {
  color: #323c46;
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
}

.edume-text-slot {
  color: #848a90;
  font-size: 13px;
  line-height: 18px;
  margin: 0;
}

.edume-due-date {
  display: flex;
  align-items: center;
  gap: 4px; /* space between svg and text */
  color: #323c46;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
}

.edume-text-container p {
  margin: 0;
}

.edume-image > img {
  border-radius: 4px 0 0 4px;
  background-color: var(--app-colour);
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: var(--image-size);
  object-fit: cover;
}
</style>
